import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from 'projects/bis-shared/src/lib/snackbar/snackbar.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { PriorAuthWorkRequestAssignee } from 'projects/bis-shared/src/lib/work-request-shared/prior-auth-work-request-assignee';
import { ISelectOption } from 'projects/bis-shared/src/lib/dynamic-forms/models/select-option';
import { ISelectOptionGroup } from 'projects/bis-shared/src/lib/dynamic-forms/models/select-option-group';
import { PriorAuthWorkRequestService } from '../prior-auth-work-request.service';
import { IDynamicFormGroupDefinition } from 'projects/bis-shared/src/lib/dynamic-forms/models/dynamic-form-group';
import { DynamicFormsService } from 'projects/bis-shared/src/lib/dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { MatIconModule } from '@angular/material/icon';
import { SelectInputComponent } from 'projects/bis-shared/src/lib/dynamic-forms/dynamic-form-inputs/select-input/select-input.component';
import { MatButtonModule } from '@angular/material/button';
import { DynamicFormLoadDirective } from 'projects/bis-shared/src/lib/dynamic-forms/directives/dynamic-form-structural.directive';


@Component({
  selector: 'app-assignee-modal',
  templateUrl: './assignee-modal.component.html',
  styleUrls: ['./assignee-modal.component.scss'],
  imports: [MatIconModule, MatDialogModule, SelectInputComponent, MatButtonModule, SelectInputComponent, DynamicFormLoadDirective],
})
export class AssigneeModalComponent implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);
  private priorAuthWorkRequestService = inject(PriorAuthWorkRequestService);
  private snackbarService = inject(SnackbarService);
  data = inject<{
    title?: string;
    message: string;
    priorAuthWorkRequests: any;
}>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<AssigneeModalComponent>>(MatDialogRef);

  message: string;
  title: string;
  priorAuthRequestType: string;
  priorAuthWorkRequests: any;
  priorAuthWorkRequestIds: number[];
  getAssigneesRequest: any;
  formInfo: IDynamicFormGroupDefinition;
  assigneeForm: UntypedFormGroup;
  assigneeOptionsGroupArray: ISelectOptionGroup[] = [];
  assigneeOptionsArray: ISelectOption[] = [];
  assigneeOptions$: BehaviorSubject<ISelectOptionGroup[]> = new BehaviorSubject([]);

  
 

  constructor() {
    const data = this.data;

    this.title = data.title || 'Assign';
    this.message = data.message;
    this.priorAuthWorkRequests = data.priorAuthWorkRequests;
  }

  ngOnInit(): void {
    this.dynamicFormsService
      .getFormGroupForModel('priorAuthWorkRequestAssigneeForm')
      .subscribe(formInfo => {
        this.formInfo = formInfo;
        this.assigneeForm = formInfo.formGroup;

        if (this.priorAuthWorkRequests) {
          this.priorAuthRequestType = this.priorAuthWorkRequests[0].priorAuthorizationRequestType;
          this.getAssigneesRequest = {
            priorAuthStatusId: this.priorAuthWorkRequests[0].priorAuthStatusID,
            priorAuthRequestTypeId: this.priorAuthWorkRequests[0].priorAuthorizationRequestTypeId,
            currentAssignedSystemUserId: this.priorAuthWorkRequests[0].assignedToSystemUserId,
            priorAuthorizationId: this.priorAuthWorkRequests[0].priorAuthorizationId,
          };

          const priorAuthWorkRequestIds = this.priorAuthWorkRequests.map(wr => wr.workRequestId);
          this.assigneeForm.patchValue({ workRequestIds: priorAuthWorkRequestIds });
          this.priorAuthWorkRequestService
            .getPriorAuthWorkRequestAssignees(this.getAssigneesRequest)
            .pipe(
              map((assigneeArray: PriorAuthWorkRequestAssignee[]) => {
                for (const assignee of assigneeArray) {
                  const option: ISelectOption = {
                    name: assignee.displayName,
                    value: assignee.systemUserEntityGroupId,
                    sortOrder: 1,
                    isDeleted: false,
                  };
                  if (option.name !== null && option.value !== null) {
                    this.assigneeOptionsArray.push(option);
                  }
                }
                const optionGroupArrayOption: ISelectOptionGroup = {
                  name: 'Assignee',
                  options: this.assigneeOptionsArray,
                  sortOrder: 1,
                };
                this.assigneeOptionsGroupArray.push(optionGroupArrayOption);
                return this.assigneeOptionsGroupArray;
              }),
            )
            .subscribe(data => this.assigneeOptions$.next(data));
        }
      });
  }

  assignWorkRequest($event: any) {
    $event.preventDefault();
    this.priorAuthWorkRequestService
      .assignPriorAuthWorkRequest(this.assigneeForm.value as PriorAuthWorkRequestAssignee)
      .subscribe(
        () => {
          this.snackbarService.openSnackBarSuccess(
            `${this.priorAuthWorkRequests.length} item(s) have been updated.`,
          );
          this.dialogRef.close(true);
        },
        () => {
          this.snackbarService.openSnackBarFailure(
            'Failed to assign Work request(s) to the selected user.',
          );
          this.dialogRef.close(true);
        },
      );
  }
}
